<template>
  <div>
    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item label="Situação" prop="ativo" :rules="[$requiredChange]" key="ativo">
              <el-select v-model="dados.ativo">
                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                <el-option :key="false" label="INATIVO" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="18" :md="18">
            <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome">
              <el-input v-model="dados.nome" maxlength="100" v-on:blur="formatUpper('nome')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-tipo-alimento" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  data: () => ({
    edit: false,
    dados: {
      id: '',
      nome: '',
      ativo: true
    }
  }),
  methods: {
    getById (id) {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/tipo-alimento/getById/` + id, this.$store.getters.getHeaderAuth)
        .then(response => { this.dados = JSON.parse(JSON.stringify(response.data)) })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    onSubmit () {
      document.getElementById("btn-tipo-alimento").focus()
      this.$refs.dados.validate((valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        window.eventBus.$emit('loading', true)
        const url = this.edit
          ? `${this.$store.state.config.baseUrlApi}/api/merenda/tipo-alimento/update/${this.dados.id}`
          : `${this.$store.state.config.baseUrlApi}/api/merenda/tipo-alimento/store`
        this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
          .then(response => {
            window.eventBus.$emit('loading', false)
            if (response.data && response.data.erro) {
              const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar.')
              return window.eventBus.$emit('alert', { msg, type: 'warning' })
            }
            window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
            this.$emit('onSubmitTipoAlimento')
          }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
      })
    },
    formatUpper (field) {
      if (!this.dados[field]) return
      this.dados[field] = this.$removerAcentos(String(this.dados[field]).toUpperCase())
    }
  },
  watch: {
    paramId: {
      immediate: true,
      handler (value) {
        if (value) {
          this.getById(value)
          this.edit = true
        }
      }
    }
  }
}
</script>
